import AdvanceTable from "components/common/advance-table/AdvanceTable";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import useAdvanceTable from "hooks/useAdvanceTable";
import FalconPagination from "components/common/custom/pagination";
import React, { useEffect, useState } from "react";
import {
  Card,
  Dropdown,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useAppContext } from "providers/AppProvider";
import { getPathFromUrl, rgbaColor } from "helpers/utils";
import {
  Briefcase,
  Building,
  Chat,
  ChatFill,
  ExclamationCircle,
  Eye,
  Gear,
  Paperclip,
} from "react-bootstrap-icons";
import SubtleBadge from "components/common/SubtleBadge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ArrowRepeat } from "react-bootstrap-icons";
import CardDropdown from "components/common/CardDropdown";
import moment from "moment";
import TableComponentHeader from "./TableComponentHeader";
import { useDispatch, useSelector } from "react-redux";
import {
  ClaimSecondResponse,
  DownloadRequestClaim,
  GetAllClaimCommunications,
  GetAllHistoryLog,
  GetClaimEligibility,
  GetClaimRequest,
  ViewClaim,
  DownloadResponseClaim,
} from "../config/cliamApi";
import paths from "routes/paths";
import ClaimConfirmationDeleteModal from "./ClaimConfirmationDeleteModal.js";
import ErrorClaimModal from "./ErrorClaimModal.js";
import { useNavigate } from "react-router-dom";
import { CheckPreauthorizationStatus } from "features/preauthorization/config/preauthorizationApi";
import ClaimIssueModal from "./ClaimIssueModal";
import CancelClaimModal from "./CancelClaimModal";
import ClaimHistoryLogModal from "./ClaimHistoryLogModal";
import {
  faEye,
  faBan,
  faSatelliteDish,
  faComments,
  faPaperPlane,
  faDownload,
  faHistory,
  faCheck,
  faSyncAlt,
  faTrash,
  faRecycle,
} from "@fortawesome/free-solid-svg-icons";
import ClaimCommunicationsListModal from "../../preauthorization/components/ClaimCommunicationsListModal.js";
import SendClaimCommunicationModal from "../../preauthorization/components/SendClaimCommunicationModal.js";
import ErrorDisplayModal from "features/preauthorization/components/ErrorDisplayModal.js";
import SuccessModal from "components/wizard/StatusCheckStatusModal";
import ErrorResubmitClaimModal from "./ErrorResubmitClaimModal.js";
import ClaimDocumentRequestModal from "./ClaimDocumentRequestModal.js";
const ClaimListTable = ({
  handlePerRowsChange,
  handlePageChange,
  totalRows,
  setTotal,
  setStatusCounts,
  requestBody,
  setError: setFormError,
  setTotalRows,
  setPage,
  setRowsPerPage,
  data,
  page,
  rowsPerPage,
}) => {
  const dispatch = useDispatch();
  const { cliamTypeList } = useSelector((state) => state.claim);
  const { allPermissionType } = useSelector((state) => state.role);
  const claimsSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) =>
      item?.rolemngmttyp_name === "Claim" ||
      item?.rolemngmttyp_name === "Claims",
  );
  const { getThemeColor } = useAppContext();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [selectedClaim, setSelectedClaim] = useState(null);
  const [error, setError] = useState(null);
  const [openError, setOpenError] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [showHistoryLog, setShowHistoryLog] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [showCommunications, setShowCommunications] = useState(false);
  const [showSendCoummunication, setShowSendCommunication] = useState(false);
  const [successDescription, setSuccessDescription] = useState(false);
  const [showErrorStatusModal, setShowErrorStatusModal] = useState(false);
  const [title, setTitle] = useState("");
  const [errorDescription, setErrorDescription] = useState(false);
  const [resubmitError, setResubmitError] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [resubmitBody, setResubmitBody] = useState(false);
  const [status, setStatus] = useState(null);
  const [row, setRow] = useState(null);
  const body = requestBody(0, 10);
  const totalBody = requestBody(0, totalRows);

  const handleViewClaimIssues = async (row) => {
    const claim_type = cliamTypeList?.find(
      (item) => item?.claim_types_code === row?.preauthclmtyp,
    )?.claim_types_id;
    const response = await dispatch(
      ViewClaim({
        claimid: row?.claimfull_id,
        claim_type,
      }),
    ).unwrap();
    if (response?.success) {
      setSelectedClaim(row);
      setShowModal(true);
    }
  };

  const columns = [
    {
      accessorKey: "index",
      header: "#",
      cell: ({ row }) => (
        <div className="d-flex align-items-center ">
          <div
            className="rounded-circle bg-200 d-flex flex-center fs-11"
            style={{ width: "30px", height: "30px" }}
          >
            {page * rowsPerPage + row.index + 1}
          </div>
        </div>
      ),
    },
    {
      accessorKey: "insurance_shname",
      header: "Payer",
      cell: ({ row: { original } }) => (
        <div className="fs-11 ">
          {original.insurance_direct === 0
            ? `${original.payer_name} - ${original.insurance_shname}`
            : original.payer_name}
        </div>
      ),
    },
    {
      accessorKey: "claimfull_id",
      header: "Claim Number",
      cell: ({ row: { original } }) => (
        <div className="fs-11">{original?.claimfull_id || ""}</div>
      ),
    },
    {
      accessorKey: "claim_date",
      header: "Date",
      cell: ({ row: { original } }) => (
        <div className="fs-11 ">
          {moment(original.claim_date).format("DD-MM-YYYY") || "-"}
        </div>
      ),
    },
    {
      accessorKey: "patient",
      header: "Patient",
      cell: ({ row: { original } }) => (
        <div className="d-flex flex-column ">
          <div className="fs-11 text-700">
            {`${original?.patient_mrn || ""} - ${
              original.patient_firstname || ""
            } ${original.patient_familyname || ""}`}
          </div>
          <div className="text-500 fs-11">
            {original?.patient_identifier
              ? `${original?.patient_identifier} - `
              : ""}{" "}
            {original.patient_nationalid}
          </div>
        </div>
      ),
    },
    {
      accessorKey: "polcyno",
      header: "Policy No.",
      cell: ({ row: { original } }) => (
        <div className="d-flex justify-content-center flex-column">
          <div className="fs-11 fw-medium text-success">
            {original?.polcyno || ""}
          </div>
          <div className="fs-11 text-500 fw-normal ">
            {original?.polcyname || ""}
          </div>
        </div>
      ),
    },
    {
      accessorKey: "preauthclmtyp",
      header: "Claim Type",
      cell: ({ row: { original } }) => {
        const typeConfig = {
          institutional: {
            bg: rgbaColor(getThemeColor("primary"), 0.1),
            color: getThemeColor("primary"),
            icon: <Building />,
          },
          dental: {
            bg: rgbaColor(getThemeColor("danger"), 0.1),
            color: getThemeColor("danger"),
            icon: <i className="fas fa-tooth" />,
          },
          pharmacy: {
            bg: rgbaColor(getThemeColor("info"), 0.1),
            color: getThemeColor("info"),
            icon: <i className="fas fa-pills" />,
          },
          professional: {
            bg: rgbaColor(getThemeColor("success"), 0.1),
            color: getThemeColor("success"),
            icon: <Briefcase />,
          },
          vision: {
            bg: rgbaColor(getThemeColor("warning"), 0.1),
            color: getThemeColor("warning"),
            icon: <Eye />,
          },
        };

        const typeKey = original?.preauthclmtyp?.toLowerCase();
        const config = typeConfig[typeKey] || {
          bg: "#f8f9fa",
          color: "#000",
          icon: <i className="fas fa-question-circle me-1" />,
        };

        return (
          <div className="d-flex flex-column justify-content-start ">
            <div className="text-success fw-medium fs-11">
              {original?.preauthclmtyp === "oral"
                ? "Dental"
                : original.preauthclmtyp.charAt(0).toUpperCase() +
                  original.preauthclmtyp.slice(1)}
            </div>
            <div className="text-500 fw-normal fs-11">
              {original?.claimsub_types_disp_name &&
                original.claimsub_types_disp_name.charAt(0).toUpperCase() +
                  original.claimsub_types_disp_name.slice(1)}
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: "doctor",
      header: "Doctors/Specialities",
      cell: ({ row: { original } }) => (
        <div className="d-flex flex-column ">
          <div className="fs-11 text-700">
            {`${original?.practitioner_name}`}
          </div>
          <div className="text-500 fs-11">{original?.crteam_spclty}</div>
        </div>
      ),
    },
    {
      accessorKey: "grossamount",
      header: "Gross",
      cell: ({ row: { original } }) => {
        const value = parseFloat(original.grossamount);
        return (
          <div className="fs-11 ">{isNaN(value) ? "-" : value.toFixed(2)}</div>
        );
      },
    },
    {
      accessorKey: "netamount",
      header: "Net",
      cell: ({ row: { original } }) => {
        const value = parseFloat(original.netamount);
        return (
          <div className="fs-11 ">{isNaN(value) ? "-" : value.toFixed(2)}</div>
        );
      },
    },
    {
      accessorKey: "discamnt",
      header: "Discount",
      cell: ({ row: { original } }) => {
        const value = parseFloat(original.discamnt);
        return (
          <div className="fs-11 ">
            {isNaN(value) ? "0.00" : value.toFixed(2)}
          </div>
        );
      },
    },
    {
      accessorKey: "apprveamount",
      header: "Approved",
      cell: ({ row: { original } }) => {
        const value = parseFloat(original.apprveamount);
        return (
          <div className="fs-11 ">
            {isNaN(value) ? "0.00" : value.toFixed(2)}
          </div>
        );
      },
    },
    {
      accessorKey: "submtamount",
      header: "Submitted",
      cell: ({ row: { original } }) => {
        const value = parseFloat(original.submtamount);
        return (
          <div className="fs-11 ">{isNaN(value) ? "-" : value.toFixed(2)}</div>
        );
      },
    },
    {
      accessorKey: "vatamount",
      header: "Vat",
      cell: ({ row: { original } }) => {
        const value = parseFloat(original.vatamount);
        return (
          <div className="fs-11 ">
            {isNaN(value) ? "0.00" : value.toFixed(2)}
          </div>
        );
      },
    },
    {
      accessorKey: "claim_status",
      header: "Claim Status",
      cell: ({ row: { original } }) => {
        const dispatch = useDispatch();
        const value = original.clm_status?.toLowerCase();
        const statusConfig = {
          error: { bg: "#fde6d8", color: "#ac5a2b", icon: "exclamation" },
          Error: { bg: "#fde6d8", color: "#ac5a2b", icon: "exclamation" },
          invalid: {
            bg: "#fde6d8",
            color: "#ac5a2b",
            icon: "exclamation",
          },
          "validation error": {
            bg: "#fff3cd",
            color: "#856404",
            icon: "exclamation-triangle",
          },
          "no response": {
            bg: "#08101b",
            color: "#91979e",
            icon: "circle-exclamation",
          },
          approved: { bg: "#d9f8eb", color: "#00894f", icon: "check" },
          "ready to submit": {
            bg: "#d8f3ff",
            color: "#197aa4",
            icon: "check",
          },
          "in process": {
            bg: "#ffe6cc", // soft orange background
            color: "#cc6600", // deep burnt orange text
            icon: "spinner", // conveys in-progress state
          },
          rejected: { bg: "#fbdbe1", color: "#b82c46", icon: "times" },
          cancelled: { bg: "#ffe0fe", color: "#da23aa", icon: "times" },
          "partially approved": {
            bg: "#C2EEF6",
            color: "#0da9bd",
            icon: "star-half-stroke",
          },
          pended: { bg: "#d9e7fa", color: "#215cac", icon: "clock" },
          "not-required": {
            bg: "#d8f3ff",
            color: "#197aa4",
            icon: "clock",
          },
          queued: { bg: "#fefad2", color: "#a7970d", icon: "list" },
          adjudication: { bg: "#e8dff7", color: "#6f42c1", icon: "gavel" },
          prepared: { bg: "#e6e8ec", color: "#5d6776", icon: "hammer" },
        };

        const config = statusConfig[value] || {
          bg: "#f8f9fa",
          color: "#000",
          icon: "question",
        };

        const canOpenIssues =
          value === "invalid" || value === "invalid" || !!original?.valdn_err;

        return (
          <div className="d-flex justify-content-start align-items-center gap-2">
            <SubtleBadge
              pill
              style={{
                backgroundColor: config.bg,
                color: config.color,
                border: `1px solid ${config.color}20`,
                width: "120px",
                cursor:
                  Number(claimsSetting?.view) === 1 && canOpenIssues
                    ? "pointer"
                    : "default",
              }}
              className="d-flex flex-center fs-12 p-2 gap-1"
              onClick={() => {
                if (Number(claimsSetting?.view) === 1 && canOpenIssues) {
                  handleViewClaimIssues(original);
                }
              }}
            >
              <FontAwesomeIcon
                icon={config.icon}
                transform="shrink-2"
                className="ms-1 me-1"
              />
              {value ? value.charAt(0).toUpperCase() + value.slice(1) : "-"}
            </SubtleBadge>
            {Number(claimsSetting?.view) === 1 && (
              <Button
                variant="secondary"
                size="sm"
                className="bg-secondary text-white rounded-circle p-1 d-flex align-items-center justify-content-center"
                style={{ width: "24px", height: "24px" }}
                onClick={() => {
                  setShowDocumentModal(true);
                  setRow(original);
                }}
              >
                <Paperclip size={14} />
              </Button>
            )}
            {(value === "rejected" ||
              value === "invalid" ||
              value === "error" ||
              original?.valdn_err) &&
              Number(claimsSetting?.view) === 1 && (
                <Button
                  variant=""
                  size="sm"
                  className="bg-danger text-white rounded-circle border-secondary p-1 d-flex align-items-center justify-content-center"
                  style={{ width: "24px", height: "24px" }}
                  onClick={() => handleViewClaimIssues(original)}
                >
                  <ExclamationCircle size={14} />
                </Button>
              )}

            <div className="d-flex gap-1">
              {/* Second Response Icon */}
              {original.is_secondresponse && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip
                      id="tooltip-second-response"
                      style={{
                        "--bs-tooltip-bg": "var(--bs-success)",
                        "--bs-tooltip-color": "var(--bs-white)",
                      }}
                      className="rounded"
                    >
                      Second Response
                    </Tooltip>
                  }
                >
                  <div className="text-success">
                    <ArrowRepeat style={{ width: "16px", height: "16px" }} />
                  </div>
                </OverlayTrigger>
              )}

              {/* Communication Icon with dynamic tooltip */}
              {original.is_communication && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip
                      id="tooltip-communication"
                      style={{
                        "--bs-tooltip-bg": original?.is_communication_view
                          ? "var(--bs-warning)"
                          : "var(--bs-warning)",
                        "--bs-tooltip-color": "var(--bs-white)",
                      }}
                      className="rounded"
                    >
                      {original.is_communication_view ? "Read" : "Unread"}
                    </Tooltip>
                  }
                >
                  <div
                    className={`cursor-pointer ${
                      original.is_communication_view
                        ? "text-success"
                        : "text-warning"
                    }`}
                    onClick={async () => {
                      const response = await dispatch(
                        GetAllClaimCommunications({
                          claimid: original?.claimfull_id,
                          claim_type: original?.claim_type,
                        }),
                      ).unwrap();

                      if (response?.success) {
                        setShowCommunications(true);
                        setRow(original);
                      }
                    }}
                  >
                    {original.is_communication_view ? (
                      <Chat
                        className="text-warning"
                        style={{ width: "16px", height: "16px" }}
                      />
                    ) : (
                      <ChatFill
                        className="text-warning"
                        style={{ width: "16px", height: "16px" }}
                      />
                    )}
                  </div>
                </OverlayTrigger>
              )}
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: "action",
      header: <Gear />,
      cell: ({ row: { original } }) => {
        const status = original?.clm_status?.toLowerCase();
        const isWithdrown = status === "withdrawn";
        const isValid = status === "ready to submit";
        const statusConfig = {
          showRequest: true,
          showResponse: [
            "invalid",
            "approved",
            "pended",
            "queued",
            "rejected",
            "partially approved",
            "cancelled",
            "no response",
            "withdrawn",
          ].includes(status),
          showCancel: [
            "approved",
            "pended",
            "rejected",
            "partially approved",
            "queued",
            "invalid",
          ].includes(status),
          showHistoryLog: true,
          showCommunications: [
            "approved",
            "pended",
            "queued",
            "rejected",
            "partially approved",
            "cancelled",
            "invalid",
          ].includes(status),
          showSecondResponse: [
            "no response",
            "queued",
            "pended",
            "approved",
          ].includes(status),
          showSubmit: ["ready to submit", "no response"].includes(status),
          showWithDrown: isValid,
          showDelete: [
            "ready to submit",
            "withdrawn",
            "validation error",
          ].includes(status),
          // showDelete: true,
          showUnWithWrown: isWithdrown,
          showNewCommunication: [
            "approved",
            "pended",
            "queued",
            "rejected",
            "partially approved",
            "cancelled",
            "invalid",
          ].includes(status),

          showDownloadRequest: !isWithdrown,
          showStatusCheck: [
            "approved",
            "pended",
            "queued",
            "partially approved",
            "cancelled",
          ].includes(status),
          showResubmit: [
            "invalid",
            "pended",
            "rejected",
            "cancelled",
            "queued",
          ].includes(status),
          showDocument: [
            "invalid",
            "Ready to Submit",
            "rejected",
            "cancelled",
            "approved",
          ].includes(status),
          showDownloadResponse: ![
            "no response",
            "invalid",
            "ready to submit",
          ].includes(status),
        };

        const handleViewClaimResponse = async (row) => {
          const response = await dispatch(
            ViewClaim({
              claimid: row?.claimfull_id,
              claim_type: row?.claim_type,
            }),
          ).unwrap();

          if (response?.success) {
            navigate(`${paths.viewClaimResponse}/${row?.claimfull_id}`);
          }
        };

        const handleViewClaimRequest = async (row) => {
          const response = await dispatch(
            ViewClaim({
              claimid: row?.claimfull_id,
              claim_type: row?.claim_type,
            }),
          ).unwrap();

          if (response?.success) {
            navigate(
              `${paths.viewClaimRequest}/${row?.claimfull_id}?claim_type=${row?.claim_type}`,
            );
          }
        };

        const handleDownloadRequestJSON = async (row) => {
          try {
            // Step 1: Dispatch the API call
            const response = await dispatch(
              DownloadRequestClaim({
                claimid: row?.claimfull_id,
                claim_type: row?.claim_type,
              }),
            ).unwrap();
            const downloadUrl = response?.data?.request_file;

            if (!downloadUrl) {
              throw new Error("Download URL not found.");
            }

            // Step 2: Fetch the file from the download URL
            const fileResponse = await fetch(downloadUrl);

            if (!fileResponse.ok) {
              throw new Error("Failed to fetch the JSON file.");
            }

            const blob = await fileResponse.blob();

            // Step 3: Extract the filename from the URL
            const urlParts = downloadUrl.split("/");
            const filename = urlParts[urlParts.length - 1] || "downloaded.json";

            // Step 4: Save the blob as a file
            saveAs(blob, filename);
          } catch (error) {
            console.error("Error downloading the JSON file:", error);
          }
        };

        const handleDownloadResponseJSON = async (row) => {
          try {
            // Step 1: Dispatch the API call
            const response = await dispatch(
              DownloadResponseClaim({
                claimid: row?.claimfull_id,
                claim_type: row?.claim_type,
              }),
            ).unwrap();
            const downloadUrl = response?.data?.response_file;

            if (!downloadUrl) {
              throw new Error("Download URL not found.");
            }

            // Step 2: Fetch the file from the download URL
            const fileResponse = await fetch(downloadUrl);

            if (!fileResponse.ok) {
              throw new Error("Failed to fetch the JSON file.");
            }

            const blob = await fileResponse.blob();

            // Step 3: Extract the filename from the URL
            const urlParts = downloadUrl.split("/");
            const filename = urlParts[urlParts.length - 1] || "response.json";

            // Step 4: Save the blob as a file
            saveAs(blob, filename);
          } catch (error) {
            console.error("Error downloading the JSON file:", error);
          }
        };

        const handleCancelClaim = (row) => {
          setShowCancel(true);
          setRow(row);
        };

        const handleWidthDrown = async (row) => {
          setConfirmDelete(true);
          setRow(row);
          setStatus("withdrawn");
          // const response = await dispatch(
          //   WidthDrownDeleteClaim({
          //     claim_data: [
          //       {
          //         claimid: row?.claimfull_id,
          //         claim_type: row?.claim_type,
          //         claim_status: "withdrawn",
          //       },
          //     ],
          //   })
          // ).unwrap();

          // if (response?.success) {
          //   setPage(0);
          //   setRowsPerPage(10);
          //   toast.success(response?.message_en);
          //   await dispatch(GetAllClaimsList(body)).unwrap();
          // }
        };
        const handleUnwithdraw = async (row) => {
          setConfirmDelete(true);
          setRow(row);
          setStatus("unwithdrawn");
          // const response = await dispatch(
          //   WidthDrownDeleteClaim({
          //     claim_data: [
          //       {
          //         claimid: row?.claimfull_id,
          //         claim_type: row?.claim_type,
          //         claim_status: "unwithdrawn",
          //       },
          //     ],
          //   })
          // ).unwrap();

          // if (response?.success) {
          //   setPage(0);
          //   setRowsPerPage(10);
          //   toast.success(response?.message_en);
          //   await dispatch(GetAllClaimsList(body)).unwrap();
          // }
        };
        const handleResubmitClaim = async (row) => {
          setConfirmDelete(true);
          setRow(row);
          setStatus("resubmit");
          // const response = await dispatch(
          //   ResubmitClaim({
          //     claimid: row?.claimfull_id,
          //     claim_type: row?.claim_type,
          //     claim_retype: "resubmit",
          //     cncl_reason: "",
          //   })
          // ).unwrap();

          // if (response?.success) {
          //   setPage(0);
          //   setRowsPerPage(10);
          //   toast.success(response?.message_en);
          //   await dispatch(GetAllClaimsList(body)).unwrap();
          // } else {
          //   toast.error(
          //     `(${response?.data?.error_code}) - ${response?.data?.error_msg}`
          //   );
          // }
        };
        const handleDeleteClaim = async (row) => {
          setConfirmDelete(true);
          setRow(row);
          setStatus("delete");
          // const response = await dispatch(
          //   WidthDrownDeleteClaim({
          //     claim_data: [
          //       {
          //         claimid: row?.claimfull_id,
          //         claim_type: row?.claim_type,
          //         claim_status: "delete",
          //       },
          //     ],
          //   })
          // ).unwrap();

          // if (response?.success) {
          //   setPage(0);
          //   setRowsPerPage(10);
          //   toast.success(response?.message_en);
          //   await dispatch(GetAllClaimsList(body)).unwrap();
          // }
        };

        const handleHistoryLog = async (row) => {
          setRow(row);
          const response = await dispatch(
            GetAllHistoryLog({
              claimid: row?.claimfull_id,
              claim_type: row?.claim_type,
            }),
          ).unwrap();
          if (response?.success) {
            setShowHistoryLog(true);
          }
        };

        const handleSubmitIndividualClaim = async (row) => {
          setRow(row);
          setConfirmDelete(true);
          setStatus("submit");
        };

        const handleShowCommunications = async (row) => {
          const response = await dispatch(
            GetAllClaimCommunications({
              claimid: row?.claimfull_id,
              claim_type: row?.claim_type,
            }),
          ).unwrap();

          if (response?.success) {
            setShowCommunications(true);
            setRow(row);
          }
        };

        const handleSendCommunication = (row) => {
          setShowSendCommunication(true);
          setRow(row);
        };
        const handleCheckStatus = async (row) => {
          const response = await dispatch(
            CheckPreauthorizationStatus({
              pauthclmid: row?.claimid,
              claim_type: row?.claim_type,
              status_type: "claim",
            }),
          ).unwrap();

          // if (response?.data?.output?.status !== "complete") {
          //   setErrorDescription("No Status Information Available");
          //   setTitle("Status Information");
          //   setShowErrorStatusModal(true);
          // } else {
          setShowSuccessModal(true);
          setSuccessDescription(response?.data?.status);
          // }
        };

        const handleSecondResponse = async (row) => {
          const response = await dispatch(
            ClaimSecondResponse({
              claimid: row?.claimid,
              claim_type: row?.claim_type,
              claimnatre: "secndresp",
            }),
          ).unwrap();
          if (response?.success) {
            setShowSuccessModal(true);
            setSuccessDescription(response?.message_en);
          } else {
            setShowErrorStatusModal(true);
            setTitle("Claim Not Submitted");
            setErrorDescription(response?.data?.second_resp_errormsg);
          }
        };

        const actions = [
          {
            show: Number(claimsSetting?.view) === 1 && statusConfig.showRequest,
            label: "View Claim Request",
            icon: <FontAwesomeIcon icon={faEye} className="me-2" />,

            onClick: () => handleViewClaimRequest(original),
          },
          {
            show:
              Number(claimsSetting?.view) === 1 && statusConfig.showResponse,
            label: "View Claim Response",
            icon: <FontAwesomeIcon icon={faEye} className="me-2" />,

            onClick: () => handleViewClaimResponse(original),
          },
          {
            show:
              Number(claimsSetting?.cancel) === 1 && statusConfig.showCancel,
            label: "Cancel",
            icon: <FontAwesomeIcon icon={faBan} className="me-2" />,

            onClick: () => handleCancelClaim(original),
          },
          {
            show:
              Number(claimsSetting?.view) === 1 && statusConfig.showStatusCheck,
            label: "Status Check",
            icon: <FontAwesomeIcon icon={faSatelliteDish} className="me-2" />,

            onClick: () => handleCheckStatus(original),
          },
          {
            show:
              (Number(claimsSetting?.view) === 1 ||
                Number(claimsSetting?.submit) === 1) &&
              statusConfig.showCommunications,
            label: "Communications",
            icon: <FontAwesomeIcon icon={faComments} className="me-2" />,

            onClick: () => handleShowCommunications(original),
          },
          {
            show:
              Number(claimsSetting?.submit) === 1 &&
              statusConfig.showNewCommunication,
            label: "Send Communication",
            icon: <FontAwesomeIcon icon={faPaperPlane} className="me-2" />,

            onClick: () => handleSendCommunication(original),
          },
          {
            show:
              Number(claimsSetting?.submit) === 1 && statusConfig.showResubmit,
            label: "Resubmit Claim",
            icon: <FontAwesomeIcon icon={faSyncAlt} className="me-2" />,

            onClick: () => handleResubmitClaim(original),
          },
          {
            show:
              Number(claimsSetting?.submit) === 1 &&
              statusConfig.showSecondResponse,
            label: "Second Response",
            icon: <FontAwesomeIcon icon={faRecycle} className="me-2" />,

            onClick: () => handleSecondResponse(original),
          },
          {
            show:
              Number(claimsSetting?.submit) === 1 && statusConfig.showSubmit,
            label: "Submit",
            icon: <FontAwesomeIcon icon={faCheck} className="me-2" />,

            onClick: () => handleSubmitIndividualClaim(original),
          },
          {
            show:
              Number(claimsSetting?.cancel) === 1 && statusConfig.showWithDrown,
            label: "Withdraw",
            icon: <FontAwesomeIcon icon={faBan} className="me-2" />,

            onClick: () => handleWidthDrown(original),
          },
          {
            show:
              Number(claimsSetting?.cancel) === 1 &&
              statusConfig.showUnWithWrown,
            label: "Un Withdrawn",
            icon: <FontAwesomeIcon icon={faSyncAlt} className="me-2" />,

            onClick: () => handleUnwithdraw(original),
          },
          {
            show:
              Number(claimsSetting?.delete) === 1 && statusConfig.showDelete,
            label: "Delete Claim",
            icon: <FontAwesomeIcon icon={faTrash} className="me-2" />,

            onClick: () => handleDeleteClaim(original),
          },
          {
            show:
              Number(claimsSetting?.export) === 1 &&
              statusConfig.showDownloadRequest,
            label: "Download JSON Request",
            icon: <FontAwesomeIcon icon={faDownload} className="me-2" />,

            onClick: () => handleDownloadRequestJSON(original),
          },
          {
            show:
              Number(claimsSetting?.export) === 1 &&
              statusConfig.showDownloadResponse,
            label: "Download JSON Response",
            icon: <FontAwesomeIcon icon={faDownload} className="me-2" />,

            onClick: () => handleDownloadResponseJSON(original),
          },
          {
            show:
              Number(claimsSetting?.view) === 1 && statusConfig.showHistoryLog,
            label: "History Log",
            icon: <FontAwesomeIcon icon={faHistory} className="me-2" />,
            onClick: () => handleHistoryLog(original),
          },
        ];

        return (
          <CardDropdown
            icon="ellipsis-v"
            dropdownClassName="py-2 custom-dropdown-menu"
          >
            {actions
              .filter((action) => action.show)
              .map((action, idx) => (
                <Dropdown.Item key={idx} onClick={action.onClick}>
                  {action.icon}
                  {action.label}
                </Dropdown.Item>
              ))}
          </CardDropdown>
        );
      },
    },
  ];

  const table = useAdvanceTable({
    data,
    columns,
    manualPagination: true,
    pageCount: Math.ceil(totalRows / rowsPerPage),
    selection: true,
    selectionColumnWidth: 40,
    state: {
      pagination: {
        pageIndex: page,
        pageSize: rowsPerPage,
      },
    },
  });

  useEffect(() => {
    table.setPagination({ pageIndex: page, pageSize: rowsPerPage });
    table.resetRowSelection();
  }, [page, rowsPerPage, data]);
  return (
    <div className="mb-3 mt-3">
      {Number(claimsSetting?.list) === 1 ? (
        data?.length > 0 ? (
          <>
            <TableComponentHeader
              table={table}
              body={body}
              setFormError={setFormError}
              totalBody={totalBody}
              setPage={setPage}
              setRowsPerPage={setRowsPerPage}
            />
            <AdvanceTableProvider {...table}>
              <AdvanceTable
                tableProps={{
                  size: "sm",
                  className: "fs-10 mb-0 overflow-hidden",
                  striped: true,
                }}
                headerClassName="bg-200 text-nowrap align-middle"
                rowClassName="align-middle white-space-nowrap"
              />
            </AdvanceTableProvider>
            <Card.Footer className="d-flex mt-2 mb-3 justify-content-end align-items-center">
              <FalconPagination
                currentPage={page}
                rowsPerPage={rowsPerPage}
                totalRecords={totalRows}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePerRowsChange}
              />
            </Card.Footer>
          </>
        ) : (
          <div className="text-center border py-3">No Data To Show</div>
        )
      ) : (
        <div className="text-center py-5">
          <h5 className="text-danger">Permission Denied</h5>
          <p className="text-muted fs-11">
            You do not have permission to view this list.
          </p>
        </div>
      )}

      {showModal && selectedClaim && (
        <ClaimIssueModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          claim={selectedClaim}
        />
      )}

      <CancelClaimModal
        show={showCancel}
        setShow={setShowCancel}
        row={row}
        page={page}
        rowsPerPage={rowsPerPage}
        setTotal={setTotal}
        setOpenError={setOpenError}
        body={body}
        setError={setError}
        setTotalRows={setTotalRows}
        setStatusCounts={setStatusCounts}
      />

      <ClaimConfirmationDeleteModal
        show={confirmDelete}
        onClose={() => setConfirmDelete(false)}
        row={row}
        status={status}
        body={body}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        setResubmitError={setResubmitError}
        setOpenError={setOpenError}
        setError={setError}
        setResubmitBody={setResubmitBody}
      />

      <ErrorClaimModal
        show={openError}
        onClose={() => setOpenError(false)}
        error={error}
        setConfirmDelete={setConfirmDelete}
      />
      <ErrorResubmitClaimModal
        show={resubmitError}
        onClose={() => setResubmitError(false)}
        body={resubmitBody}
        claimBody={body}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        setError={setError}
        setOpenError={setOpenError}
      />

      <ClaimHistoryLogModal
        show={showHistoryLog}
        setShow={setShowHistoryLog}
        row={row}
        setRow={setRow}
        page={page}
        rowsPerPage={rowsPerPage}
        setTotal={setTotal}
        setTotalRows={setTotalRows}
        setStatusCounts={setStatusCounts}
      />

      <ClaimCommunicationsListModal
        show={showCommunications}
        onHide={() => setShowCommunications(false)}
        modalRow={row}
      />

      {showSendCoummunication && (
        <SendClaimCommunicationModal
          modal={showSendCoummunication}
          setModal={setShowSendCommunication}
          modalRow={row}
        />
      )}
      <ErrorDisplayModal
        modal={showErrorStatusModal}
        setModal={setShowErrorStatusModal}
        title={title}
        description={errorDescription}
      />
      <SuccessModal
        modal={showSuccessModal}
        setModal={setShowSuccessModal}
        title="Status Information"
        description={successDescription}
      />
      {showDocumentModal && (
        <ClaimDocumentRequestModal
          row={row}
          setShowModal={setShowDocumentModal}
          setRow={setRow}
          showModal={showDocumentModal}
          body={body}
        />
      )}
    </div>
  );
};

export default ClaimListTable;
